import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '@justgiving/modal';
import CopyToClipboard from '@justgiving/copy-to-clipboard';
import { useTracking } from '@justgiving/react-tracking';

import { useNotNullableContext } from '../../hooks/useNotNullableContext';
import { PageMetaContext } from '../../context/PageMetaContext';
import parseCurrency from '../../utils/parseCurrency';
import FacebookShare from '../SocialButtons/FacebookShare';
import EmailShare from '../SocialButtons/EmailShare';
import TwitterShare from '../SocialButtons/TwitterShare';

import styles from './SuccessMessage.scss';

type SuccessMessageModalProps = {
  isModalOpen: boolean;
  onCloseModal: () => any;
  currencyCode: string;
  defaultCurrencyAmount: number;
};

const trackingData = { page_section: 'campaign created success message' };

const SuccessMessageModal: React.FunctionComponent<SuccessMessageModalProps> = ({
  isModalOpen,
  onCloseModal,
  currencyCode,
  defaultCurrencyAmount,
}) => {
  const { currentUrl } = useNotNullableContext(PageMetaContext);
  const track = useTracking();
  const [copiedToClipboard, setCopiedToClipboard] = useState(false);
  const { t } = useTranslation('common', { useSuspense: false });

  function copyToClipBoard() {
    track({
      ...trackingData,
      event_value: 'copy link',
    });
    setCopiedToClipboard(true);
  }

  return (
    <Modal isOpen={isModalOpen} onRequestClose={onCloseModal}>
      <div className="jg-text--center">
        <h1>{t('campaign.shareYourPage')}</h1>
        <p>{t('campaign.letEveryoneKnow')}</p>
        <p>
          <strong>{t('campaign.boostDonations')}</strong>
          <span className="jg-color--primary">
            {currencyCode && parseCurrency(currencyCode, defaultCurrencyAmount)}
          </span>
        </p>
        <div
          className={`jg-campaign-share-modal-content ${styles.campaignShareModalContent}`}
        >
          <div className="jg-space-mbmd">
            <FacebookShare
              className={`jg-pages-social-button-list__button ${styles.buttonNoMax}`}
              trackingData={trackingData}
            />
          </div>
          <div className="jg-space-mbmd">
            <EmailShare trackingData={trackingData} />
          </div>
          <div className="jg-space-mbmd">
            <TwitterShare
              className="jg-pages-social-button-list__button"
              trackingData={trackingData}
            />
          </div>
          <div>
            <CopyToClipboard
              text={`${currentUrl}?invite=true`}
              copyMessage={t('common.copyLink')}
              copiedMessage={t('common.linkCopied')}
              copied={copiedToClipboard}
              onCopy={copyToClipBoard}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default SuccessMessageModal;
